import { render, staticRenderFns } from "./HeaderPill.vue?vue&type=template&id=8d59d1bc&scoped=true&"
import script from "./HeaderPill.vue?vue&type=script&lang=js&"
export * from "./HeaderPill.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPill.vue?vue&type=style&index=0&id=8d59d1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d59d1bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBadge,VChip,VIcon,VTooltip})
